import { useState } from 'react';
import { createSlug } from '../../../components/utils/utils'

export const useCustomColumns = () => {
    const [customColumns, setCustomColumns] = useState([]);

    const balanceAndPayableColumnsCalc = (args) => {
        let row;
        //Because we call this function from both excelQueryCellInfo & Syncfusion Grid Column Template
        //there is some inconsistency in args structure that I resolved it by following line.
        if (args.data) row = args.data; else row = args;
        let driverBalance = 0; //row.totalCashPayment || 0;
        driverBalance += +row.totalCardPayment || 0;
        
        let correction = 0;

        const beamFieldName = 'beamFee';
        if (!isNaN(row[beamFieldName])) {
            driverBalance -= (parseFloat(row[beamFieldName]));
        }

        const orgFieldName = 'orgIncome';
        if (!isNaN(row[orgFieldName])) {
            driverBalance -= (parseFloat(row[orgFieldName]));
        }

        if (Array.isArray(customColumns)) {
            for (let column of customColumns) {
                let colConfig = column.config;
                let computedValue;

                if (colConfig.type === "number") {
                    const fieldName = colConfig.fieldName;
                    if (!isNaN(row[fieldName])) {
                        computedValue = (parseFloat(row[fieldName]));
                    }
                } else if (colConfig.type === "percentage") {
                    computedValue = percentageColumnValueCalc(row, colConfig);
                }
                if (computedValue) {
                    correction += parseFloat(computedValue) * colConfig.coefficient;
                }
            }
        }
        
        let finalBalance = driverBalance + correction;
        let payable = finalBalance > 0 ? Math.abs(finalBalance) : 0;

        if (args.column.headerText === 'Driver Balance') {
            return finalBalance.toFixed(2);
        } else
        if (args.column.headerText === 'Driver Payable') {
            return payable.toFixed(2);
        } else 
        if (args.column.headerText === 'Total Correction') {
            return correction.toFixed(2);
        } else return '';
    };

    function CreateNewCustomColumnFieldName(caption) {
        let index = 0;
        let fieldName = createSlug(caption);

        const isFieldExist = (index) => customColumns.some(col => col.config.fieldName === `${fieldName}_${index}`);

        while (isFieldExist(index)) {
            index++;
        }

        return `${fieldName}_${index}`;
    }


    const percentageColumnValueCalc = (args, colConfig) => {
        const fieldName = colConfig.fieldName;
        // console.log(`percentageColumnValueCalc >> fieldName: ${fieldName}`);

        let computedValue;
        if (!isNaN(args[fieldName]) && !isNaN(args[colConfig.sourceField])) {
            computedValue = (parseFloat(args[fieldName]) * parseFloat(args[colConfig.sourceField]) / 100).toFixed(2);
        } else {
            computedValue = '';
        }
        return computedValue;
    };

    const reAssignPercentageCalcFunction = (customColumns) => {
        customColumns?.forEach((customColumn) => {
            customColumn.gridColumns.forEach((column) => {
                if (column.field.endsWith("_computed")) {
                    column.template = (args) => percentageColumnValueCalc(args, customColumn.config);
                }
            })
        });
    }

    const getPercentageCalcValue = (excelQueryCellInfo_args, computedfieldName) => {
        if (!customColumns) return;  // If customColumns is null or undefined, exit early

        for (const customColumnIndex in customColumns) {
            const customColumn = customColumns[customColumnIndex];

            for (const columnIndex in customColumn.gridColumns) {
                const column = customColumn.gridColumns[columnIndex];
                if (column.field.endsWith("_computed") && column.field === computedfieldName) {
                    const res = percentageColumnValueCalc(excelQueryCellInfo_args.data, customColumn.config);
                    return res;
                }
            }
        }
    }

    const populateInitialData_forCustomColumnField = (data, col) => {
        return data.map(row => {
            let newRow = { ...row };
            const fieldName = col.config.fieldName;
            if (col.config.type === "number") {
                newRow[fieldName] = col.config.initValue;
            }
            else if (col.config.type === "percentage") {
                newRow[fieldName] = col.config.initValue;
            }
            return newRow;
        });
    };

    const generateColumnsForConfig = (colConfig) => {
        const fieldName = CreateNewCustomColumnFieldName(colConfig.caption);
        colConfig.fieldName = fieldName;

        const add_subtract_CSS_Class = colConfig.coefficient < 0 ? 'subtract-column' : 'add-column';

        const newColumnsForGrid = [
            {
                key: `${fieldName}_mainkey`,
                field: fieldName,
                headerText: colConfig.type === "number" ? `${colConfig.caption} ($)` : `${colConfig.caption} (%)`,
                // template: (rowData) => <CustomCell rowData={rowData} field={fieldName} />,
                width: 45,
                textAlign: 'Center',
                // format: colConfig.type === "number" ? 'C2' : 'P2',
                allowEditing: true,
                type: colConfig.type,
                cssClass: colConfig.type === "percentage" ? 'percentage-column' : add_subtract_CSS_Class
            }
        ];

        if (colConfig.type === "percentage") {
            newColumnsForGrid.push({
                key: `${fieldName}_computedkey`,
                field: `${fieldName}_computed`,
                headerText: `${colConfig.caption} ($)`,
                template: args => percentageColumnValueCalc(args, colConfig),
                width: 45,
                textAlign: 'Center',
                // format: 'C2',
                cssClass: add_subtract_CSS_Class
            });
        }

        return {fieldName , newColumnsForGrid};
    };

    const getValidationRules = (columnType) => {
        if (columnType === 'percentage') {
            return {
                required: true,
                range: [0, 100]
            };
        } else if (columnType === 'number') {
            return {
                required: true,
                min: 0
            };
        }
        return {};
    }


    // Return the state variables and functions that need to be used in RidesPaymentCalculations.js
    return {
        customColumns,
        setCustomColumns,
        balanceAndPayableColumnsCalc,
        percentageColumnValueCalc,
        populateInitialData_forCustomColumnField,
        generateColumnsForConfig,
        reAssignPercentageCalcFunction,
        getValidationRules,
        getPercentageCalcValue
    };
};
